// @flow
import type PostProcessingRule from "./PostProcessingRule";

export class LIValidationError extends Error {
    constructor(message:string, failedProcessingRule:PostProcessingRule) {
        super(message);
        this.name = "LIValidationError";
        this.failedPostProcessingRule = failedProcessingRule;
    }
}